import { render, staticRenderFns } from "./signSuccessPage.vue?vue&type=template&id=73017226&scoped=true"
import script from "./signSuccessPage.vue?vue&type=script&lang=js"
export * from "./signSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./signSuccessPage.vue?vue&type=style&index=0&id=73017226&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73017226",
  null
  
)

export default component.exports